export const CREATED_RULE_EVENT = 'createdRuleEvent';
export const RULE_UPDATED_EVENT = 'Rule Updated Event';
export const UPDATE_REJECTED_SUMMARY = 'UPDATE_REJECTED_SUMMARY';
export const UI_FIELD_SELECTED_EVENT = 'UI Field Selected';
export const RULE_SET_EVENT = 'ruleSetEvent';
export const NEW_RULE_EVENT_FROM_OUTSIDE = 'NewRuleEventFromOutside';
export const NEW_STATUS_RULE_EVENT_FROM_OUTSIDE = 'NewStatusRuleEventFromOutside';